import type { ContentCourseWithLessons, ContentPage } from '@doneverse/shared'
import { api } from '../api/index.js'

export interface MasterclassVaultCourseSummary {
  id: string
  page_slug: string
  slug: string
  position: number
  title: string
  summary: string | null
  card_image_url: string | null
  recorded_at: string | null
  created_at: string
  updated_at: string
  lesson_count: number
  viewed_lesson_count: number
}

export interface MasterclassVaultCatalog {
  page: ContentPage
  courses: MasterclassVaultCourseSummary[]
}

export interface MasterclassVaultCourseDetail {
  page: { slug: string; title: string }
  course: ContentCourseWithLessons
}

export const masterclassVaultService = {
  // Returns null when the vault hasn't been published yet (API 404s on a missing
  // content_pages row) so the page renders its empty state instead of throwing.
  catalog: async (): Promise<MasterclassVaultCatalog | null> => {
    return api
      .get('/masterclass-vault')
      .notFound(() => null)
      .json<MasterclassVaultCatalog>()
  },
  course: async (courseSlug: string): Promise<MasterclassVaultCourseDetail> => {
    return api
      .get(`/masterclass-vault/${encodeURIComponent(courseSlug)}`)
      .json<MasterclassVaultCourseDetail>()
  },
}
